import { useState, useCallback, useMemo } from "react";
import { TestResponse } from "@/types/test-response";

export function useSearchResponses(responses: TestResponse[]) {
  const [searchQuery, setSearchQuery] = useState("");

  const handleSearchChange = useCallback((query: string) => {
    setSearchQuery(query);
  }, []);

  const filteredResponses = useMemo(() => {
    if (!searchQuery.trim()) {
      return responses;
    }

    const query = searchQuery.toLowerCase().trim();
    
    return responses.filter((response) => {
      const candidateName = response.candidate?.full_name?.toLowerCase() || "";
      const candidateEmail = response.candidate?.email?.toLowerCase() || "";
      
      return candidateName.includes(query) || candidateEmail.includes(query);
    });
  }, [responses, searchQuery]);

  return {
    searchQuery,
    handleSearchChange,
    filteredResponses,
  };
}